import axios from 'axios';

const state = {
    dashboardStatistics: {
        totalUsers: 0,
        uniqueAccounts: 0,
        totalProducts: 0,
        totalCustomers: 0,
        totalSuppliers: 0,
        totalLocations: 0,
    },
    dashboardRestock: {
        restockNeeded: 0,
        restockItems: [],
    },
};


const mutations = {
    SET_DASHBOARD_STATISTICS(state, statistics) {
        state.dashboardStatistics = statistics;
    },
    SET_DASHBOARD_RESTOCK(state, restock) {
        state.dashboardRestock = restock;
    },
};

const actions = {
    async fetchDashboardStatistics({ commit }) {
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            // Redirect to login page if token is not found
            router.push({ name: 'login' });
            return;
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/dashboard`, { headers: { Authorization: `Bearer ${userToken }` }, });
            console.log('API Response:', response.data);
            commit('SET_DASHBOARD_STATISTICS', response.data);
        } catch (error) {
            console.error('Error fetching user statistics:', error);
            throw error; // Handle on the component side if needed
        }
    },
    async fetchRestock({ commit }) {
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            router.push({ name: 'login' });
            return;
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/restock`, { headers: { Authorization: `Bearer ${userToken}` } });
            console.log('API Response:', response.data);
            const products = response.data;
    
            // Map response array to your object structure
            const restockData = {
                restockNeeded: products.length,
                restockItems: products,
            };
            commit('SET_DASHBOARD_RESTOCK', restockData);
        } catch (error) {
            console.error('Error fetching restock data:', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};